import React,{useState} from 'react'
import notesContext from '../context/notes/notesContext'
import { useContext } from 'react'

const AddNote = (props) => {
    const context= useContext(notesContext)
    const{addNote}=context
    const [note,setNote]=useState({title :"",description :"",tag:"default"})
   const handleClick=(e)=>{
       e.preventDefault();
       addNote(note.title,note.description,note.tag);
       props.showAlert("Notes is added successfully","success")
       setNote({ title: '', description: '', tag: 'default' });
    }
    
   const handleChange=(e)=>{
        setNote({...note,[e.target.name] : e.target.value})
    }
  return (
    <div>
         <div className='container my-3'>
    <h1 className='text-center'>Create Your Memories</h1>
    <form>
  <div className="mb-3">
    <label htmlFor="title" className="form-label">Title</label>
    <input type="text" className="form-control" id="title" name="title" aria-describedby="emailHelp" onChange={handleChange} style={{backgroundColor:'#BFDBFE'}} value={note.title} />
    
  </div>
  <div className="mb-3">
    <label htmlFor="description" className="form-label">Content</label>
    <textarea type="text" className="form-control" id="description" name="description" style={{height:'200px'}} onChange={handleChange} style={{backgroundColor:'#BFDBFE'}} value={note.description} />
  </div>
  
  <div className="mb-3">
    <label htmlFor="tag" className="form-label">Tag</label>
    <input type="text" className="form-control" id="tag" name="tag" onChange={handleChange} style={{backgroundColor:'#BFDBFE'}} value={note.tag} />
  </div>

  <button type="submit" className="btn btn-primary" onClick={handleClick}>Create</button>
</form>


    </div>
    </div>
  )
}

export default AddNote